import { render, staticRenderFns } from "./shift_report.vue?vue&type=template&id=6ff94e79&"
import script from "./shift_report.vue?vue&type=script&lang=js&"
export * from "./shift_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports